import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Button, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { styled } from '@mui/material/styles'
import dayjs from 'dayjs';
import { PAYMENT_METHOD, convertMoney, getOrderId } from '../../../../utils/utils';
import { useAtomValue } from 'jotai';
import { authAtom } from '../../../../actions';
import { MultiSelect } from 'react-multi-select-component';
import './style.css'

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


const DailyReportItem = ({ report, index, onDelete, services = [], onSelectServices }) => {
    const history = useHistory()

    const pastServicesString = report?.past_orders?.map((item) => {
        return `${item.service.name} - ${dayjs(item.order_date).format('DD/MM/YYYY')}`
    }).join(', ')

    // const newOrdersString = report?.new_orders?.map((item) => {
    //     return `${item.service.name} - ${dayjs(item.order_date).format('DD/MM/YYYY')}`
    // }).join(', ')

    const openDetail = () => {
        history.push(`/crm/lead/${report?.lead?.user?.username}/${report?.lead.id}`)
      }

    const serviceOptions = services.map((item) => ({ label: item.name, value: item.id }))

    return (
        <StyledTableRow
            key={report?.id ? report?.id.toString() : ''}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
        >
            <TableCell>
                <Button
                    variant="contained"
                    color="error"
                    onClick={() => onDelete && onDelete()}
                >
                    Xóa
                </Button>
            </TableCell>
            <TableCell>{index + 1}</TableCell>
            <TableCell>{report?.lead?.user?.full_name}</TableCell>
            <TableCell>
                <a 
                    href={`/crm/lead/${report?.lead?.user?.username}/${report?.lead.id}`} 
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                >
                    {report?.lead?.user?.username}
                </a>
            </TableCell>
            <TableCell>{report?.source}</TableCell>
            <TableCell>{report?.source_detail}</TableCell>
            <TableCell>{report?.user_identifier}</TableCell>
            <TableCell>{pastServicesString}</TableCell>
            <TableCell>{report?.message?.note}</TableCell>
            <TableCell>{report?.status}</TableCell>
            <TableCell>{report?.new_services_str}</TableCell>
            {/* <TableCell sx={{ display: 'flex', justifyContent: 'flex-start', width: '200px'}}>
                <MultiSelect
                    options={serviceOptions}
                    value={(report?.new_services ?? []).map((item) => ({ label: item.name, value: item.id }))}
                    onChange={(selected) => {
                        console.log({ selected })
                        if(onSelectServices) {
                            onSelectServices(selected)
                        }
                    }}
                    style={{width: '200px'}}
                    labelledBy="Chọn dịch vụ"
                    overrideStrings={{
                        "allItemsAreSelected": "Tất cả",
                        "clearSearch": "Xoá",
                        "clearSelected": "Bỏ chọn",
                        "search": "Tìm kiếm",
                        "selectAll": "Chọn tất cả",
                        "selectAllFiltered": "Chọn tất cả",
                        "selectSomeItems": "Chọn dịch vụ"
                    }}
                    
                    hasSelectAll={false}
                />
            </TableCell> */}
            <TableCell>{report?.expected}</TableCell>
            <TableCell>{report?.new_orders_str}</TableCell>
            <TableCell>{report?.new_direct_income ? convertMoney(report?.new_direct_income) : ''}</TableCell>
            <TableCell>{report?.new_other_income ? convertMoney(report?.new_other_income) : ''}</TableCell>
            <TableCell>{report?.income_category}</TableCell>
            <TableCell>{report?.note}</TableCell>
            <TableCell>{report?.booking_date}</TableCell>
        </StyledTableRow>
    )
}

export default DailyReportItem